import { GetterTree } from 'vuex';
import { RootState } from '@/interface/store/';
import { ManageGroup } from '@/interface/store/manageGroups';

export const getters: GetterTree<ManageGroup, RootState> = {
  getterMe: (state) => state.meData,
  getterGroupsMemberships: (state) => state.fkUserMemberships,
  getterMembers: (state) => state.memberList,
  getterMainLocations: (state) => state.mainLocationList,
  getterSubLocations: (state) => state.subLocationList,
  getterSubLocationName: (state) => state.subLocationName,
  getterTypes: (state) => state.typeList,
  getterTypeFields: (state) => state.typeFieldList,
  getterTypeFieldItem: (state) => state.typeFieldItem,
  getterVendors: (state) => state.vendorList,
  getterVendorItem: (state) => state.vendorItem,
  getterManufacturers: (state) => state.manufacturerList,
  getterManufacturerItem: (state) => state.manufacturerItem,
  getterAddresses: (state) => state.addressList,
  getterAddressItem: (state) => state.addressItem,
  getterGrants: (state) => state.grantList,
  getterGrantItem: (state) => state.grantItem,
  getterSettings: (state) => state.settings,
};
